



export const setEnablingStrategyTemplates = (templates) => ({
    type:"EST_SET_TEMPLATES",
    templates
});